/* ============================================================================
   MPAD — share sheet · share URLs · sold-out tiers                      v1.3
   ----------------------------------------------------------------------------
   Loads AFTER mpad-theme.js and overrides behaviour without touching it.

     1. SHARE      the share button opens the device's own share sheet, and
                   copies the link when the sheet cannot run. It hands out the
                   product URL, which is short and gets a real preview card.
     2. SOLD OUT   a tier that has sold out is removed from the picker — in the
                   buy popup AND on the product page, which had the same bug.
                   Nothing left at all: the picker goes, the button says Sold
                   out, and the show card on the Shows page says Sold out too.
     3. SECTIONS   the product page gets the popup's own layout back —
                   About the show and Location & directions as accordions,
                   and the share button, which it never had.
     4. LINKS      old ?ticket= links still resolve, and a link whose show is
                   no longer on the page falls through to the product page
                   instead of silently doing nothing.

   Everything is wrapped so a failure here can never block a click that the
   original theme would have handled.
   ========================================================================== */
(function () {
  'use strict';

  var POPUP_ID  = 'mpadBuyPopup';
  var SHARE_SEL = '[data-tkt-share]';
  var BUY_SEL   = '[data-buy-popup]';
  var CHIP_SEL  = '.size[data-opt-index], .mpad-opt[data-opt-index]';
  var PARAM     = 'ticket';   /* kept alive so links already advertised still work */

  /* ------------------------------------------------------------------ utils */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function safe(fn) { return function () { try { return fn.apply(this, arguments); } catch (e) { if (window.console) console.warn('[mpad-fixes]', e); } }; }

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function toast(msg) {
    if (typeof window.mpadToast === 'function') { window.mpadToast(msg); return; }
    var el = document.createElement('div');
    el.className = 'mpad-fix-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('gone'); }, 2200);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 2700);
  }

  function productHandleFromPath() {
    var parts = location.pathname.split('/products/');
    if (parts.length < 2) return '';
    var rest = parts[1], cut = rest.length;
    ['/', '?', '#'].forEach(function (ch) {
      var i = rest.indexOf(ch);
      if (i !== -1 && i < cut) cut = i;
    });
    return cut > 0 ? decodeURIComponent(rest.slice(0, cut)) : '';
  }

  /* Read the show payload off a buy button. The theme stores the handle as a
     JSON string in data-product and the real arrays in data-variants/options. */
  function payload(btn) {
    if (!btn) return null;
    var out = { el: btn, handle: '', title: '', when: '', venue: '', variants: [] };
    var raw = btn.getAttribute('data-product');
    if (raw) {
      var p = null;
      try { p = JSON.parse(raw); } catch (e) { p = raw; }
      if (typeof p === 'string') out.handle = p;
      else if (p && typeof p === 'object') {
        out.handle = p.handle || '';
        if (p.variants) out.variants = p.variants;
      }
    }
    try { var v = JSON.parse(btn.getAttribute('data-variants') || 'null'); if (v && v.length) out.variants = v; } catch (e) {}
    out.title = btn.getAttribute('data-title') || '';
    out.when  = btn.getAttribute('data-when') || '';
    out.venue = btn.getAttribute('data-venue') || '';
    if (!out.title) {
      var card = btn.closest('.ticket');
      var h3 = card && card.querySelector('h3');
      if (h3) out.title = h3.textContent.trim();
    }
    return out;
  }

  function buttonForHandle(handle) {
    var want = String(handle).toLowerCase(), found = null;
    $$(BUY_SEL).forEach(function (b) {
      if (found) return;
      var p = payload(b);
      if (p && p.handle && p.handle.toLowerCase() === want) found = b;
    });
    return found;
  }

  /* ------------------------------------------------- 1. the share behaviour */

  /* The theme opens the popup from a delegated click on the buy button, so a
     capture listener here always sees the button first and can remember it. */
  var openShow = null;
  document.addEventListener('click', safe(function (e) {
    var btn = e.target.closest && e.target.closest(BUY_SEL);
    if (btn) { openShow = payload(btn); setTimeout(function () { decorate(document.getElementById(POPUP_ID), openShow); }, 60); }
  }), true);

  function shareUrl(show) {
    /* The product URL is short, canonical, and the only form that gets a real
       preview card in WhatsApp and Instagram — the show's own image, title and
       price instead of the generic Shows card. It is also a full page rather
       than a popup, so a shared link never depends on a modal opening. */
    return location.origin + root() + 'products/' + encodeURIComponent(show.handle);
  }

  function shareText(show) {
    var bits = [];
    if (show.title) bits.push(show.title);
    var line2 = [show.when, show.venue].filter(Boolean).join(' · ');
    if (line2) bits.push(line2);
    return bits.join(' — ');
  }

  function legacyCopy(url, done) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    if (ok) { done(); return; }
    toast('Could not copy — long-press the link to copy it');
  }

  function copyLink(url) {
    var done = function () { toast('Link copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { legacyCopy(url, done); });
      return;
    }
    legacyCopy(url, done);
  }

  document.addEventListener('click', safe(function (e) {
    var btn = e.target.closest && e.target.closest(SHARE_SEL);
    if (!btn) return;

    /* Take the click off the original handler, which swallowed every failure
       and so did nothing at all when the sheet was unavailable. */
    e.preventDefault();
    e.stopImmediatePropagation();

    var show = openShow;
    if (!show || !show.handle) {
      var host = btn.closest('.ticket');
      show = payload(host && host.querySelector(BUY_SEL));
    }
    /* On a product page there is no buy card to read — use what the page
       itself knows, and fall back to the URL. */
    if ((!show || !show.handle) && pageShow && pageShow.handle) show = pageShow;
    if ((!show || !show.handle) && productHandleFromPath()) {
      show = { handle: productHandleFromPath(), title: document.title.split(' – ')[0].trim(), when: '', venue: '' };
    }
    if (!show || !show.handle) { toast('Nothing to share here'); return; }

    var url = shareUrl(show);
    var data = { title: show.title || 'Tickets', text: shareText(show) || show.title, url: url };

    /* navigator.share must run inside the gesture — it does, this handler is
       synchronous. Cancelling stays silent; anything else copies the link so
       the button always visibly does something. */
    if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
      var p;
      try { p = navigator.share(data); } catch (err) { copyLink(url); return; }
      if (p && p.catch) {
        p.catch(function (err) {
          if (err && err.name === 'AbortError') return;
          copyLink(url);
        });
      }
      return;
    }
    copyLink(url);
  }), true);

  /* --------------------------------------------------- 2. sold-out tiers go */

  var busy = false;

  function chipGroups(scope) {
    var byIndex = {};
    $$(CHIP_SEL, scope).forEach(function (chip) {
      var i = chip.getAttribute('data-opt-index');
      (byIndex[i] = byIndex[i] || []).push(chip);
    });
    return Object.keys(byIndex).map(function (i) { return { index: parseInt(i, 10), chips: byIndex[i] }; });
  }

  function variantOptions(v) {
    if (v.options && v.options.length) return v.options;
    return [v.option1, v.option2, v.option3].filter(function (x) { return x !== null && x !== undefined; });
  }

  /* A value survives when at least one in-stock variant carries it while
     agreeing with what is already chosen on the other options. */
  function valueAvailable(variants, index, value, chosen) {
    return variants.some(function (v) {
      if (v.available === false) return false;
      var vo = variantOptions(v);
      if (String(vo[index]) !== String(value)) return false;
      for (var i = 0; i < chosen.length; i++) {
        if (i === index || chosen[i] == null) continue;
        if (String(vo[i]) !== String(chosen[i])) return false;
      }
      return true;
    });
  }

  function submitFor(scope) {
    if (scope && scope.id === POPUP_ID) return $('[data-buy-submit]', scope);
    var sel = $('select[name=id]');
    var form = sel && sel.closest('form');
    if (!form) return null;
    return form.querySelector('button[type=submit], button.btn-pink');
  }

  function optionWrap(scope) {
    if (scope && scope.id === POPUP_ID) return $('[data-buy-options]', scope);
    var chip = $(CHIP_SEL, scope);
    return chip && chip.closest('.opt-row, .qv-size-wrap, .field');
  }

  /* The popup writes its headline price once and never again, so changing tier
     used to leave the old price above the new ticket. Each chip carries its
     own formatted price — mirror it up rather than re-doing the money format. */
  function syncPrice(scope, groups) {
    var priceEl = $('[data-buy-price]', scope);
    if (!priceEl || groups.length !== 1) return;
    var sel = groups[0].chips.filter(function (c) { return c.classList.contains('sel'); })[0];
    var tag = sel && sel.querySelector('.chip-price');
    if (tag && tag.innerHTML) priceEl.innerHTML = tag.innerHTML;
  }

  function decorate(scope, show) {
    if (!scope || busy) return;
    if (!show || !show.variants || !show.variants.length) return;

    var groups = chipGroups(scope);
    var anything = show.variants.some(function (v) { return v.available !== false; });
    var submit = submitFor(scope);
    var wrap = optionWrap(scope);

    /* Nothing left at all: take the picker away entirely and say so once. */
    if (!anything) {
      if (wrap) wrap.classList.add('is-soldout');
      if (submit) { submit.disabled = true; submit.textContent = 'Sold out'; }
      return;
    }
    if (wrap) wrap.classList.remove('is-soldout');
    if (submit && submit.textContent === 'Sold out') { submit.disabled = false; submit.textContent = 'Add to cart'; }
    if (!groups.length) return;

    var chosen = [];
    groups.forEach(function (g) {
      var sel = g.chips.filter(function (c) { return c.classList.contains('sel'); })[0];
      chosen[g.index] = sel ? sel.getAttribute('data-opt-value') : null;
    });

    var reselect = null;
    groups.forEach(function (g) {
      var firstOpen = null;
      g.chips.forEach(function (chip) {
        var ok = valueAvailable(show.variants, g.index, chip.getAttribute('data-opt-value'), chosen);
        /* Gone means gone — the tier is removed from the row, not dimmed. */
        chip.classList.toggle('is-soldout', !ok);
        chip.disabled = !ok;
        if (ok && firstOpen === null) firstOpen = chip;
      });
      var sel = g.chips.filter(function (c) { return c.classList.contains('sel'); })[0];
      if (sel && sel.classList.contains('is-soldout') && firstOpen && !reselect) reselect = firstOpen;
    });

    /* Click rather than move the class: the theme's own handler is what keeps
       the hidden variant input and the price in step. */
    if (reselect) {
      busy = true;
      try { reselect.click(); } finally { busy = false; }
      return decorate(scope, show);
    }

    syncPrice(scope, groups);
  }

  /* ------------------------------------------------------ where it runs ---- */

  function watchPopup() {
    var pop = document.getElementById(POPUP_ID);
    if (!pop) return;
    var opts = $('[data-buy-options]', pop);
    if (opts && window.MutationObserver) {
      new MutationObserver(safe(function () { decorate(pop, openShow); })).observe(opts, { childList: true });
    }
    pop.addEventListener('click', safe(function (e) {
      if (e.target.closest && e.target.closest(CHIP_SEL)) setTimeout(function () { decorate(pop, openShow); }, 0);
    }));
  }

  /* Rebuild the popup's own layout on the product page. Every h3 in the
     description ("About the show", "Terms and conditions", "Location and
     directions") becomes one collapsed accordion in the theme's .acc block,
     so the page reads exactly as the popup did and Add to cart stays near the
     top. Everything above the first h3 — the date, the venue, the seating
     note — stays visible. */
  function buildSections() {
    var desc = $('.rte.desc') || $('.rte');
    if (!desc || $('.mpad-sections', desc)) return;
    var kids = Array.prototype.slice.call(desc.children);

    var marks = [];
    kids.forEach(function (el, i) { if (el.tagName === 'H3') marks.push(i); });
    if (!marks.length) return;

    var box = document.createElement('div');
    box.className = 'acc mpad-sections';

    marks.forEach(function (start, n) {
      var end = (n + 1 < marks.length) ? marks[n + 1] : kids.length;
      var det = document.createElement('details');
      var sum = document.createElement('summary');
      sum.textContent = (kids[start].textContent || '').trim();
      det.appendChild(sum);
      var body = document.createElement('div');
      body.className = 'rte';
      for (var i = start + 1; i < end; i++) body.appendChild(kids[i]);
      det.appendChild(body);
      box.appendChild(det);
    });

    marks.forEach(function (i) { if (kids[i].parentNode) kids[i].parentNode.removeChild(kids[i]); });
    desc.appendChild(box);

    /* The directions link gets the theme's own arrow-link treatment. */
    $$('a', box).forEach(function (a) { a.classList.add('link-more'); });
  }

  /* The product page never had a share button — the only one lives inside the
     popup, hidden. Clone it so it inherits the theme's icon styling and the
     share handler above picks it up unchanged. */
  function addShareButton() {
    var src = $('[data-tkt-share]');
    var info = $('.product-info');
    if (!src || !info || $('.product-info [data-tkt-share]')) return;

    var btn = src.cloneNode(true);
    btn.hidden = false;
    btn.removeAttribute('hidden');

    var price = $('.price', info);
    if (!price) { info.appendChild(btn); return; }

    /* Sit it on the price line, right-aligned — the popup put it top-right. */
    var row = document.createElement('div');
    row.className = 'mpad-share-row';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    row.appendChild(btn);
  }

  /* The product page has the same picker and had the same bug. */
  var pageShow = null;
  function initProductPage(handle) {
    fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
      .then(function (p) {
        pageShow = { handle: p.handle, title: p.title, variants: p.variants || [], when: '', venue: '' };
        /* The first line of the description is the date and venue — reuse it
           so a shared link carries the same text the popup used to send. */
        var meta = $('.rte.desc p') || $('.rte p');
        if (meta) {
          var lines = (meta.innerText || '').split('\n');
          pageShow.when = (lines[0] || '').trim();
          pageShow.venue = (lines[1] || '').trim();
        }
        decorate(document, pageShow);
        document.addEventListener('click', safe(function (e) {
          if (e.target.closest && e.target.closest(CHIP_SEL)) setTimeout(function () { decorate(document, pageShow); }, 0);
        }));
      })
      .catch(function () {});
  }

  /* A ticket card goes to its product page, never a popup. The theme has a
     per-show setting for this, but it has to be set again for every new show
     and a missed one silently reverts to the modal — so make it the rule.
     Runs after markSoldOutCards, which has already retired the dead ones. */
  function linkTicketsToProductPages() {
    $$('.ticket ' + BUY_SEL).forEach(safe(function (btn) {
      var p = payload(btn);
      if (!p || !p.handle) return;
      var a = document.createElement('a');
      a.className = btn.className;
      a.href = root() + 'products/' + encodeURIComponent(p.handle);
      a.textContent = (btn.textContent || 'Buy tickets').trim();
      btn.parentNode.replaceChild(a, btn);
    }));
  }

  /* A show whose every tier has gone says so on the card itself. */
  function markSoldOutCards() {
    $$('.ticket ' + BUY_SEL).forEach(safe(function (btn) {
      var p = payload(btn);
      if (!p || !p.variants || !p.variants.length) return;
      if (p.variants.some(function (v) { return v.available !== false; })) return;

      var card = btn.closest('.ticket');
      var dead = document.createElement('span');
      dead.className = 'btn btn-light buy is-disabled';
      dead.setAttribute('aria-disabled', 'true');
      dead.setAttribute('data-sold-handle', p.handle || '');
      dead.textContent = 'Sold out';
      btn.parentNode.replaceChild(dead, btn);

      var pill = card && card.querySelector('.status');
      if (pill) { pill.className = 'status sold'; pill.textContent = 'Sold out'; }
    }));
  }

  /* ----------------------------------------------- 3. old ?ticket= links --- */

  function revealCard(card) {
    if (!card) return;
    if (card.offsetParent === null) {
      var all = $('[data-loc-tabs] [data-loc="all"]');
      if (all) all.click();
      var search = $('#mpadTicketSearch');
      if (search && search.value) {
        search.value = '';
        search.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    try { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { card.scrollIntoView(); }
  }

  function openTicket(handle) {
    var btn = buttonForHandle(handle);
    if (btn) {
      revealCard(btn.closest('.ticket'));
      setTimeout(function () { btn.click(); }, 260);
      return true;
    }
    var gone = $('[data-sold-handle="' + String(handle).replace(/"/g, '') + '"]');
    if (gone) {
      revealCard(gone.closest('.ticket'));
      setTimeout(function () { toast('That show is sold out'); }, 400);
      return true;
    }
    return false;
  }

  /* Not on this page — send them to the product page, which always exists,
     rather than silently doing nothing, which is what a broken link looks
     like to whoever it was sent to. */
  function rescue(handle) {
    fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('gone');
        location.replace(root() + 'products/' + encodeURIComponent(handle));
      })
      .catch(function () {
        toast('That show is no longer on sale');
        try {
          var u = new URL(location.href);
          u.searchParams.delete(PARAM);
          history.replaceState({}, '', u.pathname + u.search + u.hash);
        } catch (e) {}
      });
  }

  function resolveFromUrl() {
    var handle;
    try { handle = new URL(location.href).searchParams.get(PARAM); } catch (e) { handle = null; }
    if (!handle) return;
    if (openTicket(handle)) return;
    setTimeout(function () { if (!openTicket(handle)) rescue(handle); }, 700);
  }

  /* ---------------------------------------------------------------- styles */

  function styles() {
    if (document.getElementById('mpad-fixes-css')) return;
    var css = [
      '.size.is-soldout,.mpad-opt.is-soldout{display:none !important}',
      '.opt-row.is-soldout,.qv-size-wrap.is-soldout,[data-buy-options].is-soldout{display:none !important}',
      '.mpad-sections{margin-top:18px}',
      '.mpad-share-row{display:flex;align-items:center;justify-content:space-between;gap:14px}',
      '.mpad-fix-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:9999;',
      'background:#141414;color:#fff;padding:11px 18px;border-radius:999px;font-size:14px;',
      'box-shadow:0 8px 30px rgba(0,0,0,.28);transition:opacity .35s}',
      '.mpad-fix-toast.gone{opacity:0}'
    ].join('');
    var tag = document.createElement('style');
    tag.id = 'mpad-fixes-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /* ------------------------------------------------------------------ start */

  function init() {
    styles();
    watchPopup();
    markSoldOutCards();
    linkTicketsToProductPages();

    var handle = productHandleFromPath();
    if (handle) { buildSections(); addShareButton(); initProductPage(handle); return; }

    resolveFromUrl();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safe(init));
  else safe(init)();

  window.mpadFixes = { version: '1.4.0', decorate: decorate };
})();
